export const PublicRoutes = ['/pdfPreview'];

export const PhoneRegex = /^[^A-Za-z]*$/;

export type PendingConfirmation = {
  beneId: number;
  caseId: number;
  type: AddressConfirmationType;
};

export enum AddressConfirmationType {
  BeneficiaryLandingPage = 'beneficiaryLandingPage',
}

export enum FallbackPlaceholderText {
  SingleDash = '-',
  DoubleDash = '- -',
  TripleDash = '- - -',
  NotAvailable = 'N/A',
}

export enum CountryCode {
  UnitedStates = 'US',
  UnitedKingdom = 'GB',
  Ireland = 'IE',
  Global = 'GO',
}

export const DefaultInputDebounceTime = 1000; // 1 second

export enum BooleanYesNo {
  Yes = 'Yes',
  No = 'No',
}

export enum BooleanTrueFalse {
  True = 'True',
  False = 'False',
}

export const EmptyDateValue = '0001-01-01T00:00:00.000Z';

export const DefaultDateFormat = 'yyyy-MM-dd';

export const OLD_DATE = '9999/12/31';

const getDateString = (value: Date | string, isLocal: boolean = false): string | null => {
  let result: string | null = null;

  if (value) {
    if (value instanceof Date) {
      if (isLocal) {
        const month = (value.getMonth() + 1).toString().padStart(2, '0');
        const day = value.getDate().toString().padStart(2, '0');
        result = `${value.getFullYear()}-${month}-${day}`;
      } else {
        result = value.toISOString().split('T')[0];
      }
    } else if (typeof value === 'string') {
      const match = value.match(/^\d{4}-\d{2}-\d{2}/);
      if (match !== null) {
        result = match[0];
      }
    }
  }

  if (result === '0001-01-01') {
    result = null;
  }

  return result;
};

export const getDateObject = (date: Date | string): Date | null => {
  const dateString = getDateString(date);
  if (dateString) {
    return new Date(`${dateString}T00:00:00Z`);
  }
  return null;
};

export const SUPPORTED_PRINT_FILE_TYPES = ['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png'];

export enum DocumentsDownloadType {
  Default = 'Default',
  Print = 'Print',
}

export const DocumentPrintingPagePlaceholder = 'Loading...';

export const USER_TYPES = {
  balAdmin: 'BAL_ADMIN',
  balAssistant: 'BAL_ASSISTANT',
  ccm: 'COUNTRY_CASE_MANAGER',
  balManager: 'BAL_MANAGER',
  beneficiary: 'BENEFICIARY',
  hrContact: 'HR_CONTACT',
  hrLead: 'HR_LEAD',
  manager: 'MANAGER',
  networkPartnerL1: 'NETWORK_PARTNER_L1',
  networkPartnerL2: 'NETWORK_PARTNER_L2',
  networkPartnerL3: 'NETWORK_PARTNER_L3',
  kmTeam: 'KM_TEAM',
  superAdmin: 'SUPER_ADMIN',
  signer: 'SIGNER',
};

export const USER_TYPE_NAMES = {
  [USER_TYPES.beneficiary]: 'Employee',
  [USER_TYPES.hrContact]: 'HR',
  [USER_TYPES.hrLead]: 'HR',
  [USER_TYPES.manager]: 'Manager',
  [USER_TYPES.networkPartnerL1]: 'Network Partner',
  [USER_TYPES.networkPartnerL2]: 'Network Partner',
  [USER_TYPES.networkPartnerL3]: 'Network Partner',
};

export interface CheckboxOption {
  label: string;
  checked: boolean;
  disabled?: boolean;
}

export const BAL_URLS = {
  News: 'https://www.bal.com/immigration-news/',
};

export enum ImmigrationInstance {
  BAL = 'BAL',
  DELOITTE = 'Deloitte',
  ALLIANCE = 'Alliance',
}

export const CrossInstanceLabels: Record<ImmigrationInstance, string> = {
  [ImmigrationInstance.BAL]: 'Deloitte GlobalAdvantage',
  [ImmigrationInstance.DELOITTE]: 'BAL',
  [ImmigrationInstance.ALLIANCE]: '',
};

export const DONT_SHOW_GLOBAL_CASE_MODAL_KEY = 'dontShowGlobalCaseModal';
export const CONTACT_INFORMATION_TAB_INDEX = 1;
export const INTERCOM_VERTICAL_PADDING = 60;
export const GATHERING_DOCS_STAGE_NAME = 'Gathering Docs & Information';

// Questionnaire names (as returned by the case-questionnaires API) that the new AIDI experience
// fully supports today. Any other assigned questionnaire (e.g. dynamic/legal-assigned questionnaires
// like "FBI Clearance Questionnaire") must continue to be completed via the Legacy system.
export const AIDI_SUPPORTED_QUESTIONNAIRE_NAMES = ['USA - H-1B Employee Questionnaire'];
